import { useState } from 'react';
import ConfirmationDialog from '../dialog/confirm-dialog';
import { AppLink } from '@/routing';
import { cn } from '@/lib/utils';

export const ExternalLink = ({
  href,
  children = 'Tính năng này cần thao tác trên trang Admin',
  className
}: {
  href: string;
  children?: React.ReactNode;
  className?: string;
}) => {
  const [open, setOpen] = useState(false);
  const [pendingHref, setPendingHref] = useState<string | null>(null);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setPendingHref(href);
    setOpen(true);
  };

  const confirmOpenLink = () => {
    if (pendingHref) {
      window.open(pendingHref, '_blank');
    }
    setOpen(false);
    setPendingHref(null);
  };

  return (
    <>
      <AppLink href={href} onClick={handleClick} className={cn('hover:text-blue-600 hover:underline', className)}>
        {children}
      </AppLink>

      <ConfirmationDialog
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={confirmOpenLink}
        title='Thông báo'
        message={`Chuyển hướng tới Admin?`}
      />
    </>
  );
};
